import { crudActions, crudMutations } from '@/utils/crud';
import ajaxRequest from '@/utils/request';

const state = {
    shops: [],
    widgetSettings: {}
};

const getters = {
    shops: state => state.shops
};

const actions = {
    getSelectedShop(context) {
        return new Promise((resolve, reject) => {
            ajaxRequest({
                url: '/shops/get_selected/',
                success({data}) {
                    context.commit('selectShop', data);
                    resolve();
                }
            });
        });
    },
    getIntegrationInfo(context) {
        return new Promise((resolve, reject) => {
            ajaxRequest({
                url: '/shops/integration/',
                success({data}) {
                    resolve(data);
                }
            });
        });
    },
    getIntegrationDetails(context, {provider, insales_sub_domain}) {
        return new Promise((resolve, reject) => {
            ajaxRequest({
                url: `/${provider.toLowerCase()}/integration/details/`,
                params: insales_sub_domain ? {insales_sub_domain} : {},
                success({data}) {
                    resolve(data);
                }
            });
        });
    },
    beginInstallation(context, {provider}) {
        return new Promise((resolve, reject) => {
            ajaxRequest({
                url: `/${provider.toLowerCase()}/integration/install/manual/`,
                success({data}) {
                    resolve(data);
                }
            });
        });
    },
    saveInSalesIntegrationParams(context, params) {
        return new Promise((resolve, reject) => {
            ajaxRequest({
                url: '/insales/integration/params/save/',
                method: 'POST',
                params,
                success({data}) {
                    resolve(data);
                }
            });
        });
    },
    loadShops(context) {
        ajaxRequest({
            url: '/shops/get/',
            success(response) {
                context.commit('loadShops', response.data);
            }
        });
    },
    ...crudActions({
        name: 'Shop',
        urlPart: '/shops/'
    }),
    loadWidgetSettings(context) {
        return new Promise((resolve, reject) => {
            ajaxRequest({
                url: '/widget/widget_settings/get/',
                success({data}) {
                    context.commit('setWidgetSettings', {resolve, data});
                }
            });
        });
    },
    saveWidgetSettings(context, params) {
        return new Promise((resolve, reject) => {
            ajaxRequest({
                url: '/widget/widget_settings/save/',
                method: 'POST',
                params,
                success({data}) {
                    context.commit('setWidgetSettings', {resolve, data});
                }
            });
        });
    },
    getDefaultSender(context) {
        return new Promise((resolve, reject) => {
            ajaxRequest({
                url: '/delivery_order/default_sender/get/',
                success({data}) {
                    resolve(data);
                }
            });
        });
    },
    saveDefaultSender(context, params) {
        return new Promise((resolve, reject) => {
            ajaxRequest({
                url: '/delivery_order/default_sender/save/',
                method: 'POST',
                params,
                success({data}) {
                    resolve(data);
                }
            });
        });
    }
};

const mutations = {
    loadShops(state, shops) {
        state.shops = shops;
    },
    ...crudMutations({
        name: 'Shop',
        arrayName: 'shops',
        orderBy: '-number',
        editedMutation: 'changeEditedShop',
        idField: 'number'
    }),
    setWidgetSettings(state, {resolve, data}) {
        state.widgetSettings = data;
        resolve && resolve();
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};



// WEBPACK FOOTER //
// ./src/store/modules/shops.js